<template>
  <section class="donation-after-section">
    <h2>การ<strong>พักฟื้น</strong> หลังการบริจาคเลือด</h2>
    <container>
      <div class="col donation-step-container">
        <div class="donation-step">
          <img src="@/assets/donation-info/donation-after-1.png" alt="blood donation step">
          <span class="content">ทานอาหารตามปกติ แต่เน้นให้ดื่มน้ำเยอะๆ</span>
        </div>
        <div class="donation-step">
          <img src="@/assets/donation-info/donation-after-2.png" alt="blood donation step">
          <span class="content">ป้อนยาบำรุงเลือดตามที่คุณหมอแนะนำโดยเคร่งครัด</span>
        </div>
        <div class="donation-step">
          <img src="@/assets/donation-info/donation-after-3.png" alt="blood donation step">
          <span class="content">สังเกตว่ามีอาหารบวมช้ำซึม อ่อนแรง หรือเป็นลมหรือไม่ ถ้ามี ควรพาไปพบแพทย์</span>
        </div>
        <div class="donation-step">
          <img src="@/assets/donation-info/donation-after-4.png" alt="blood donation step">
          <span class="content">งดออกกำลังกายหนักๆอย่างน้อย 2-3 วัน</span>
        </div>
      </div>
    </container>
  </section>
</template>

<script>
import Container from '@/components/Container.vue'

export default {
  name: 'DonationAfterSection',
  components: {
    Container
  }
}
</script>

<style scoped lang="scss">
.donation-after-section {
  padding: 2rem 0;
  h2 {
    text-align: center;
    font-size: $h3-font-size;
    font-weight: $font-weight-light;
    strong {
      font-weight: $font-weight-normal;
    }
  }
}
@media (min-width: map-get($grid-breakpoints, "sm")) {
  .donation-after-section {
    h2 {
      font-size: $h1-font-size;
    }
  }
}
</style>
